import {
  SubscriptionStatus,
  SUBSCRIPTION_STATUS_CLASS,
  SUBSCRIPTION_STATUS_LABELS,
} from "../models/SubscriptionModels";
import "./SubscriptionStatusBadge.css";

interface SubscriptionStatusBadgeProps {
  status: number;
}

const SubscriptionStatusBadge = ({ status }: SubscriptionStatusBadgeProps) => {
  const key = status as SubscriptionStatus;
  const label = SUBSCRIPTION_STATUS_LABELS[key] ?? "Unknown";
  const cls = SUBSCRIPTION_STATUS_CLASS[key] ?? "danger";

  return (
    <span
      className={`sub-status sub-status--${cls}`}
      title={`Subscription status: ${label}`}
    >
      {label}
    </span>
  );
};

export default SubscriptionStatusBadge;